import { httpClient } from '../httpClient';
import {
  IAudioGeneration,
  CreateAudioEditingRequest,
  AudioGenerationQuery,
  PaginatedResponse,
  PaginationQuery,
} from '@packages/global';

/**
 * 用户音频编辑 API 模块（变声等）
 */
export class AudioEditingApi {
  /**
   * 分页查询音频编辑任务列表
   */
  async page(queryData: PaginationQuery<AudioGenerationQuery>): Promise<PaginatedResponse<IAudioGeneration>> {
    return httpClient.post<PaginatedResponse<IAudioGeneration>>('/user/audioGenerations/edit/page', queryData);
  }

  /**
   * 创建音频编辑任务（变声）
   */
  async create(data: CreateAudioEditingRequest): Promise<IAudioGeneration> {
    return httpClient.post<IAudioGeneration>('/user/audioGenerations/edit', data);
  }

  /**
   * 获取音频编辑任务详情
   */
  async get(id: string): Promise<IAudioGeneration> {
    return httpClient.get<IAudioGeneration>(`/user/audioGenerations/edit/${id}`);
  }
}

export const audioEditingApi = new AudioEditingApi();
